import type { ICompanyItemInterface } from '../api/CompanyItems.interface';

export const classifyItemsByType = (items: ICompanyItemInterface[]) => {
  const typeMap: Record<string, { count: number; totalQty: number }> = {};

  items.forEach((item) => {
    if (!typeMap[item.type]) {
      typeMap[item.type] = { count: 0, totalQty: 0 };
    }
    typeMap[item.type].count += 1;
    typeMap[item.type].totalQty += item.Qty;
  });

  return Object.entries(typeMap).map(([type, data]) => ({
    type,
    count: data.count,
    totalQty: data.totalQty,
  }));
};
